// ═══════════════════════════════════════════════════════
// REUSABLE STYLE OBJECTS — Extracted from repeated inline patterns
// Import theme tokens at call site: styles depend on T (theme object)
// ═══════════════════════════════════════════════════════
import { TYPE, SP, RADIUS, TRANSITION, type ThemeObject, type SpacingScale } from "./theme.js";

/** CSS-in-JS style record */
type CSSProperties = React.CSSProperties;

// ── Layout Helpers ─────────────────────────────────────

export const flexRow = (gap: string = SP[2]): CSSProperties => ({
  display: "flex",
  alignItems: "center",
  gap,
});

export const flexCol = (gap: string = SP[2]): CSSProperties => ({
  display: "flex",
  flexDirection: "column",
  gap,
});

export const flexBetween: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

// ── Typography Helpers (theme-dependent) ──────────────

export const muted = (T: ThemeObject): CSSProperties => ({
  fontSize: TYPE.xs,
  color: T.muted,
});

export const sub = (T: ThemeObject): CSSProperties => ({
  fontSize: TYPE.xs,
  color: T.sub,
});

export const subSm = (T: ThemeObject): CSSProperties => ({
  fontSize: TYPE.sm,
  color: T.sub,
});

export const label = (T: ThemeObject): CSSProperties => ({
  color: T.muted,
  fontSize: TYPE.xs,
  display: "block",
  marginBottom: SP[1],
});

// ── Spacing Shortcuts ─────────────────────────────────

export const mb = (n: keyof SpacingScale): CSSProperties => ({ marginBottom: SP[n] });
export const mt = (n: keyof SpacingScale): CSSProperties => ({ marginTop: SP[n] });

// ── Card-like containers ──────────────────────────────

export const cardBase = (T: ThemeObject): CSSProperties => ({
  background: T.card,
  borderRadius: RADIUS.lg,
  border: `1px solid ${T.border}`,
  padding: SP[5],
  transition: TRANSITION.fast,
});

export const scrollX: CSSProperties = { overflowX: "auto" };
